var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 5.21875C6.65625 5.0625 6.40625 5.0625 6.25 5.21875L5.625 5.8125C5.5 5.96875 5.5 6.21875 5.625 6.34375L11.2812 12L5.625 17.6875C5.5 17.8125 5.5 18.0625 5.625 18.2188L6.25 18.8125C6.40625 18.9688 6.65625 18.9688 6.78125 18.8125L13.3438 12.2812C13.4688 12.125 13.4688 11.9062 13.3438 11.75L6.78125 5.21875ZM11.25 5.21875L10.625 5.8125C10.5 5.96875 10.5 6.21875 10.625 6.34375L16.2812 12L10.625 17.6875C10.5 17.8125 10.5 18.0625 10.625 18.2188L11.25 18.8125C11.4062 18.9688 11.6562 18.9688 11.7812 18.8125L18.3438 12.2812C18.4688 12.125 18.4688 11.9062 18.3438 11.75L11.7812 5.21875C11.6562 5.0625 11.4062 5.0625 11.25 5.21875Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.c5663822ccfd2f4fd7383e54753b6bd1.svg";
export { ForwardRef as ReactComponent };